import ForgotPasswordComponent from "@/PageComponents/ForgotPassword/ForgotPasswordComponent";
import { createFileRoute } from '@tanstack/react-router'



const ForgotPassword = (_props: any) => {
    return <>
        <ForgotPasswordComponent />
    </>
}

export default ForgotPassword

export const Route = createFileRoute('/reset-password')({ component: ForgotPassword })
